<template>

  <div>
    <div class="row">
      <div class="col-12">
        <div style="padding-bottom: 10px">
          <el-button size="small" type="primary" @click="newMotorAccident"><i class="fa-solid fa-car"></i>
            {{$t('Yeni_müraciət_AVTO')}}
          </el-button>
          <el-button size="small" type="primary" @click="newOtherAccident"><i class="fa-solid fa-people-roof"></i>
            {{$t('Yeni_müraciət_DİGƏR')}}</el-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="button-checkbox-wrapper">
          <el-button size="small" type="info" title="Yenilə" @click="getData">
            <i class="fa-solid fa-rotate"></i> {{$t('Yenilə')}}
          </el-button>
          <el-checkbox @change="getData" v-model="mydata">{{$t('Mənim_hadisələrim')}}</el-checkbox>
        </div>
      </div>
      <div class="col-2" style="text-align: right">
        <download-excel :fields="cells" :data="data" worksheet="My Worksheet" name="responses">
          <el-button size="small" type="info"><i class="fa-solid fa-download"></i> {{$t('Export')}}
          </el-button>
        </download-excel>
      </div>
      <div class="col-md-4 col-12">
        <el-input :placeholder="$t('Axtar')" size="small" v-model="search"> </el-input>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="data.filter(
          (data) =>
            !search ||
            data.regNumber.toLowerCase().includes(search.toLowerCase()) ||
            data.insuredName.toLowerCase().includes(search.toLowerCase()) ||
            data.callPhone.toLowerCase().includes(search.toLowerCase())
        )
          " style="width: 100%">

          <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" sortable prop="policyTypeName" width="250">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı')" prop="insuredName" width="300">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_nömrəsi')" prop="phone" width="150">
          </el-table-column>
          <el-table-column :label="$t('Sığorta_predmeti')" prop="brandModel" width="250">
          </el-table-column>
          <el-table-column :label="$t('Predmet_nömrəsi')" width="250">
            <template slot-scope="scope">
              <span v-if="scope.row.policyType === 1">{{ scope.row.regNumber }}</span>
              <span v-else>{{ scope.row.policyNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Hadisə_yeri')" prop="place">
          </el-table-column>

          <el-table-column fixed="right" width="45">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                  <div class="square-icon">
                    <i class="fas fa-ellipsis-h" :title="$t('Əməliyyatlar')" style="color: #808080;"></i>
                  </div>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'edit', row: scope.row }">
                    <i class="fa-solid fa-pen-to-square"></i> {{$t('Düzəliş')}}
                  </el-dropdown-item>
                  <el-dropdown-item divided></el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'delete', row: scope.row }">
                    <i class="fa-solid fa-trash-can"></i> {{$t('Ləğv_et')}}
                  </el-dropdown-item>
                  <el-dropdown-item divided></el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'log', row: scope.row }">
                    <i class="fa-solid fa-history"></i> {{$t('Loglar')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>


        </el-table>
      </div>
    </div>



    <log-changes-dialog :visible.sync="logDialogVisible" :processed-log-diffs="processedLogDiffs" />
    <accident-motor ref="accident" @saved="saved" />
    <other-accident ref="otherAccident" @saved="saved" />
  </div>
</template>

<script>
  import {
    GetAccidentsByStage,
    DeleteAccident,
    GetAccident,
    SendToComm,
    AccidentWrongCallInsert,
    SendNewAccidentToComm
  } from "src/services/accident";
  import { MongoGetLogs } from "src/services/mongo";
  import AccidentMotor from "./AccidentMotor.vue";
  import OtherAccident from "./OtherAccident.vue";
  import { processLogDiffs } from "src/services/loghelper";
  import LogChangesDialog from "../components/LogChangesDialog.vue"
  export default {
    components: {
      AccidentMotor,
      OtherAccident,
      LogChangesDialog
    },
    data() {
      return {
        mydata: false,
        loading: false,
        data: [],
        search: "",
        accident: {},
        uid: this.$store.state.user.id,
        commNotification: [],
        cells: {
          'Zəng tarixi': 'callDateStr',
          'Hadisə tarixi': 'accidentDateStr',
          'Sığortalı': 'insuredName',
          'SŞ nömrəsi': 'policyNumber',
          'DQN': 'regNumber',
          'Marka model': 'brandModel',
          'Sürücü"': 'driver',
          'Sürücü nömrəsi"': 'driverPhone',
          'Hadisə yeri': 'place',
          'Təfərrüat': 'descr',
          'Sürücünün qeydləri': 'callNotes',
        },
        logs: [],
        processedLogDiffs: [],
        logDialogVisible: false,
        methodNames: ["UpdateAccident"],

      };
    },
    methods: {
      async showLogs(row) {
        try {
          const response = await MongoGetLogs(row.id, this.methodNames);
          
          console.log(response)
          if (!Array.isArray(response.data)) {
            this.$message.error("Server ilə əlaqə yoxdur.");
            return;
          } 

          const sorted = response.data.sort((a, b) => new Date(b.Timestamp) - new Date(a.Timestamp));

          this.logs = sorted.map((log) => ({
            Timestamp: log.Timestamp,
            MethodName: log.Properties?.MethodName || '',
            RequestData: log.Properties?.RequestData.Data || {}
          }));

          this.logDialogVisible = true;
        } catch (error) {
          console.error("Log error:", error);
          this.$message.error("Logları çəkmək mümkün olmadı.");
        }
      },
      formatKey(row, column, cellValue) {
        return cellValue;
      },
      newMotorAccident() {
        this.$refs["accident"].new();
      },
      newOtherAccident() {
        this.$refs["otherAccident"].new();
      },

      saved(value) {
        this.handleComm(value.id, value.isWrongCall, value.approachedOffice);
        this.getData();
      },
      handleCommand(command) {
        let id = command.row.id;
        let row = command.row;
        if (command.action === "edit") this.handleEdit(id, command.row.policyType);
        else if (command.action === "comm") this.handleComm(id);
        else if (command.action === "delete") this.handleDelete(id);
        else if (command.action === "log") this.showLogs(row);
      },
      handleEdit(id, policyType) {
        if (policyType === 1) {
          this.$refs["accident"].edit(id);
        }
        else {
          this.$refs["otherAccident"].edit(id);
        }
      },

      handleComm(id, isWrongCall, approachedOffice) {
        console.log(id,isWrongCall,approachedOffice)
        if (isWrongCall === 0) {
          this.$confirm("Müraciət təsdiq edilsin?", "Təsdiqləyin", {
            cancelButtonText: this.$t('Xeyr'),
            confirmButtonText: this.$t('Bəli'),
            type: "info",
            customClass: "custom-dialog-order"
          })

            .then(() => {
              this.loading = true;
              SendToComm(id, this.uid).then((response) => {
                console.log(response)
                this.loading = false;
                if (response.data.data) {
                  if (!response.data.isSuccess) {
                    this.$message({
                      type: "error",
                      message: "Səhv əməliyyat",
                    });
                  } else {
                    this.$message({
                      type: "success",
                      message: "Uğurlu əməliyyat",
                    });
                    this.getData();
                    GetAccident(id).then((response) => {
                      this.loading = false;
                      if (response.data.data) {
                        this.accident = response.data.data;
                        this.commNotification = { accidentId: id, insuranceType: 1, commUid: this.accident.accidentCommUid, mailType: 1 };

                        let acc = Object.assign({}, this.commNotification);
                        // SendNewAccidentToComm(acc)
                        //   .then(response => {
                        //   })
                        //   .catch(error => {
                        //   });
                      } else {
                        this.showModal = false;
                        this.$message({
                          type: "warning",
                          message: "Səhv əməliyyat",
                        });
                      }
                    });
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: "Səhv əməliyyat",
                  });
                }
              });
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                type: "info",
                message: "Xitam verildi",
              });
            });
        }
        this.getData();

      },
      handleDelete(id) {
        this.$confirm("Müraciət ləğv olunsun?", "Təsdiqləyin", {

          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
          customClass: 'reverse-buttons'

        })
          .then(() => {
            this.loading = true;
            DeleteAccident(id, this.uid).then((response) => {
              this.loading = false;
              if (!response.data.isSuccess) {
                if (response.data.data) {
                  this.$message({
                    type: "error",
                    message: "Səhv əməliyyat",
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Ləğv olundu",
                  });
                  this.getData();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },

      getData() {
        this.loading = true;

        GetAccidentsByStage(1, this.mydata, this.uid).then((response) => {

          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;
          }
        });
      },
    },
    mounted() {
      this.getData();
    },
    watch: {
      logs: {
        immediate: true,
        deep: true,
        async handler(newLogs) {
          this.processedLogDiffs = await processLogDiffs(newLogs, this.methodNames);
          console.log(this.processLogDiffs)
        }
      }
    }


  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .my-custom-confirm .el-message-box__btns {
    padding: 10px 20px 15px !important;
  }

  .button-checkbox-wrapper {
    display: flex;
    align-items: flex-end;
  }

  .button-checkbox-wrapper .el-checkbox {
    margin-left: 15px;
    margin-bottom: -3px;
  }
</style>